import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Star, Heart } from "lucide-react";
import { money } from "../lib/api";
import { useCart } from "../context/CartContext";

export default function ProductCard({ product, index = 0 }) {
  const { addItem } = useCart();

  const quickAdd = (e) => {
    e.preventDefault();
    addItem({
      product_id: product.id, name: product.name, price: product.price, subcategory: product.subcategory,
      quantity: 1, volume: product.volumes?.[0]?.size, image: product.images?.[0],
    });
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: (index % 4) * 0.08 }}>
      <Link to={`/product/${product.slug || product.id}`} data-testid={`product-card-${product.id}`} className="group block">
        <div className="relative overflow-hidden rounded-lg bg-[#141416] aspect-[3/4] mb-4">
          <img src={product.images?.[0]} alt={`${product.name} by ${product.brand} — ${product.subcategory}`} className="product-card-img w-full h-full object-cover" />
          <div className="absolute top-3 left-3 flex flex-col gap-1.5">
            {product.is_new_arrival && <span className="font-mono-lux uppercase tracking-[0.2em] bg-[#58111A] text-[#F7E7E8] px-2.5 py-1 rounded-full text-[0.55rem]">NEW</span>}
            {product.is_best_seller && <span className="font-mono-lux uppercase tracking-[0.2em] bg-[#D4AF37] text-[#0B0B0C] px-2.5 py-1 rounded-full text-[0.55rem]">BESTSELLER</span>}
          </div>
          <div className="absolute inset-x-0 bottom-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-500">
            <button
              data-testid={`quick-add-${product.id}`}
              onClick={quickAdd}
              className="btn-gold w-full py-2.5 rounded-full text-xs">
              Add to Bag · {money(product.price)}
            </button>
          </div>
        </div>
        <div className="flex items-center gap-1 mb-1">
          <Star size={12} className="fill-[#D4AF37] text-[#D4AF37]" />
          <span className="text-xs text-[#FAFAF7]/60">{product.rating} ({product.reviews_count})</span>
        </div>
        <p className="eyebrow text-[0.6rem] text-[#D4AF37]/60 mb-0.5">{product.brand}</p>
        <h3 className="font-serif-lux text-xl text-[#FAFAF7] leading-tight group-hover:text-[#D4AF37] transition-colors">{product.name}</h3>
        {product.description && (
          <p className="text-xs text-[#FAFAF7]/50 mt-1.5 leading-relaxed line-clamp-2">{product.description}</p>
        )}
        <p className="text-sm text-[#D4AF37] mt-2">{money(product.price)}</p>
      </Link>
    </motion.div>
  );
}
